import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";

const GradesOverview = () => {
  const routes = all_routes;

  const [children] = useState([
    { id: "1", name: "Emma Johnson", grade: "10th", class: "10-A" },
    { id: "2", name: "James Johnson", grade: "8th", class: "8-B" },
  ]);

  const [selectedChildId, setSelectedChildId] = useState("1");
  const [activeTab, setActiveTab] = useState("current");
  const [filterSubject, setFilterSubject] = useState("all");

  const selectedChild = children.find((child) => child.id === selectedChildId);

  // Mock grades data
  const gradesData = {
    summary: {
      gpa: 3.7,
      overallAverage: 87.5,
      rank: 15,
      totalStudents: 120,
      improvingSubjects: 3,
      decliningSubjects: 1,
    },
    currentGrades: [
      {
        subject: "Mathematics",
        currentGrade: "A-",
        percentage: 88,
        trend: "up",
        teacher: "Mrs. Smith",
        lastUpdated: "2024-08-20",
        assignments: 12,
        tests: 3,
      },
      {
        subject: "English",
        currentGrade: "B+",
        percentage: 87,
        trend: "stable",
        teacher: "Mr. Brown",
        lastUpdated: "2024-08-18",
        assignments: 10,
        tests: 2,
      },
      {
        subject: "Science",
        currentGrade: "A",
        percentage: 92,
        trend: "up",
        teacher: "Dr. Wilson",
        lastUpdated: "2024-08-19",
        assignments: 8,
        tests: 4,
      },
      {
        subject: "History",
        currentGrade: "B",
        percentage: 82,
        trend: "down",
        teacher: "Ms. Davis",
        lastUpdated: "2024-08-17",
        assignments: 9,
        tests: 2,
      },
      {
        subject: "Art",
        currentGrade: "A",
        percentage: 94,
        trend: "up",
        teacher: "Ms. Garcia",
        lastUpdated: "2024-08-15",
        assignments: 6,
        tests: 1,
      },
    ],
    upcomingExams: [
      {
        subject: "Mathematics",
        title: "Algebra Mid-term",
        date: "2024-08-25",
        time: "9:00 AM",
        room: "Room 101",
        chapters: "Chapters 5-7",
        type: "Mid-term",
      },
      {
        subject: "Science",
        title: "Chemistry Lab Test",
        date: "2024-08-27",
        time: "10:30 AM",
        room: "Lab 1",
        chapters: "Chemical Reactions",
        type: "Lab Test",
      },
      {
        subject: "English",
        title: "Literature Analysis",
        date: "2024-08-30",
        time: "11:00 AM",
        room: "Room 205",
        chapters: "Shakespeare Unit",
        type: "Essay Test",
      },
    ],
    recentTests: [
      {
        subject: "Mathematics",
        title: "Geometry Quiz",
        date: "2024-08-15",
        score: "18/20",
        percentage: 90,
        grade: "A-",
      },
      {
        subject: "Science",
        title: "Physics Test",
        date: "2024-08-12",
        score: "19/20",
        percentage: 95,
        grade: "A",
      },
      {
        subject: "History",
        title: "World War II Test",
        date: "2024-08-10",
        score: "16/20",
        percentage: 80,
        grade: "B-",
      },
    ],
  };

  const getGradeColor = (grade: string) => {
    if (grade.startsWith("A")) return "success";
    if (grade.startsWith("B")) return "primary";
    if (grade.startsWith("C")) return "warning";
    if (grade.startsWith("D")) return "danger";
    return "secondary";
  };

  const getTrendIcon = (trend: string) => {
    switch (trend) {
      case "up":
        return <i className="ti ti-trending-up text-success"></i>;
      case "down":
        return <i className="ti ti-trending-down text-danger"></i>;
      default:
        return <i className="ti ti-minus text-secondary"></i>;
    }
  };

  const subjects = [
    "all",
    ...Array.from(new Set(gradesData.currentGrades.map((g) => g.subject))),
  ];
  const filteredGrades =
    filterSubject === "all"
      ? gradesData.currentGrades
      : gradesData.currentGrades.filter((g) => g.subject === filterSubject);

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Header */}
          <div className="row mb-4">
            <div className="col">
              <div className="d-flex align-items-center">
                <Link
                  to={routes.parentMenu}
                  className="btn btn-outline-secondary btn-sm me-3"
                >
                  <i className="ti ti-arrow-left"></i>
                </Link>
                <div>
                  <h3 className="page-title mb-1">Grades & Exams</h3>
                  <p className="text-muted mb-0">
                    Academic performance overview
                  </p>
                </div>
              </div>
            </div>
            <div className="col-auto">
              {children.length > 1 && (
                <div className="dropdown">
                  <button
                    className="btn btn-outline-primary dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-user me-2"></i>
                    {selectedChild?.name}
                  </button>
                  <ul className="dropdown-menu">
                    {children.map((child) => (
                      <li key={child.id}>
                        <button
                          className={`dropdown-item ${
                            selectedChildId === child.id ? "active" : ""
                          }`}
                          onClick={() => setSelectedChildId(child.id)}
                        >
                          {child.name} - {child.grade} {child.class}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>

          {/* Academic Summary */}
          <div className="row mb-4">
            <div className="col-md-3 col-sm-6">
              <div className="card bg-primary-light">
                <div className="card-body text-center">
                  <div className="avatar avatar-lg bg-primary mb-2">
                    <i className="ti ti-trophy text-white fs-2"></i>
                  </div>
                  <h4 className="text-primary">{gradesData.summary.gpa}</h4>
                  <p className="mb-0">GPA</p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6">
              <div className="card bg-success-light">
                <div className="card-body text-center">
                  <div className="avatar avatar-lg bg-success mb-2">
                    <i className="ti ti-percentage text-white fs-2"></i>
                  </div>
                  <h4 className="text-success">
                    {gradesData.summary.overallAverage}%
                  </h4>
                  <p className="mb-0">Overall Average</p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6">
              <div className="card bg-info-light">
                <div className="card-body text-center">
                  <div className="avatar avatar-lg bg-info mb-2">
                    <i className="ti ti-users text-white fs-2"></i>
                  </div>
                  <h4 className="text-info">{gradesData.summary.rank}</h4>
                  <p className="mb-0">Class Rank</p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6">
              <div className="card bg-warning-light">
                <div className="card-body text-center">
                  <div className="avatar avatar-lg bg-warning mb-2">
                    <i className="ti ti-calendar-event text-white fs-2"></i>
                  </div>
                  <h4 className="text-warning">
                    {gradesData.upcomingExams.length}
                  </h4>
                  <p className="mb-0">Upcoming Exams</p>
                </div>
              </div>
            </div>
          </div>

          {/* Tabs */}
          <div className="card mb-4">
            <div className="card-header">
              <ul className="nav nav-tabs" role="tablist">
                <li className="nav-item">
                  <button
                    className={`nav-link ${
                      activeTab === "current" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("current")}
                  >
                    Current Grades
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link ${
                      activeTab === "exams" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("exams")}
                  >
                    Upcoming Exams ({gradesData.upcomingExams.length})
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link ${
                      activeTab === "recent" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("recent")}
                  >
                    Recent Tests
                  </button>
                </li>
              </ul>
            </div>
            <div className="card-body">
              {/* Current Grades Tab */}
              {activeTab === "current" && (
                <div>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <select
                        className="form-select"
                        value={filterSubject}
                        onChange={(e) => setFilterSubject(e.target.value)}
                      >
                        {subjects.map((subject) => (
                          <option key={subject} value={subject}>
                            {subject === "all" ? "All Subjects" : subject}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  {filteredGrades.map((subject) => (
                    <div key={subject.subject} className="card mb-3 border">
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-start mb-2">
                          <div className="d-flex align-items-center">
                            <div
                              className={`avatar avatar-sm bg-${getGradeColor(
                                subject.currentGrade
                              )} me-3`}
                            >
                              <i className="ti ti-book text-white"></i>
                            </div>
                            <div>
                              <h6 className="mb-1">{subject.subject}</h6>
                              <p className="text-muted mb-0">
                                {subject.teacher}
                              </p>
                            </div>
                          </div>
                          <div className="text-end">
                            <span
                              className={`badge bg-${getGradeColor(
                                subject.currentGrade
                              )} mb-1`}
                            >
                              {subject.currentGrade}
                            </span>
                            <br />
                            <span className="fw-bold">
                              {subject.percentage}%
                            </span>
                            {getTrendIcon(subject.trend)}
                          </div>
                        </div>
                        <div className="row text-center">
                          <div className="col-4">
                            <small className="text-muted d-block">
                              Assignments
                            </small>
                            <span className="fw-semibold">
                              {subject.assignments}
                            </span>
                          </div>
                          <div className="col-4">
                            <small className="text-muted d-block">Tests</small>
                            <span className="fw-semibold">{subject.tests}</span>
                          </div>
                          <div className="col-4">
                            <small className="text-muted d-block">
                              Last Updated
                            </small>
                            <span className="fw-semibold">
                              {new Date(
                                subject.lastUpdated
                              ).toLocaleDateString()}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {/* Upcoming Exams Tab */}
              {activeTab === "exams" && (
                <div>
                  {gradesData.upcomingExams.map((exam, index) => (
                    <div
                      key={index}
                      className="card mb-3 border-start border-warning border-4"
                    >
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-start">
                          <div className="d-flex align-items-center">
                            <div className="avatar avatar-sm bg-warning me-3">
                              <i className="ti ti-calendar-event text-white"></i>
                            </div>
                            <div>
                              <h6 className="mb-1">{exam.title}</h6>
                              <p className="text-muted mb-1">{exam.subject}</p>
                              <small className="text-muted">
                                {exam.chapters}
                              </small>
                            </div>
                          </div>
                          <span className="badge bg-warning">{exam.type}</span>
                        </div>
                        <div className="row text-center mt-3">
                          <div className="col-3">
                            <small className="text-muted d-block">Date</small>
                            <span className="fw-semibold">
                              {new Date(exam.date).toLocaleDateString()}
                            </span>
                          </div>
                          <div className="col-3">
                            <small className="text-muted d-block">Time</small>
                            <span className="fw-semibold">{exam.time}</span>
                          </div>
                          <div className="col-3">
                            <small className="text-muted d-block">Room</small>
                            <span className="fw-semibold">{exam.room}</span>
                          </div>
                          <div className="col-3">
                            <small className="text-muted d-block">
                              Days Left
                            </small>
                            <span className="fw-semibold text-warning">
                              {Math.ceil(
                                (new Date(exam.date).getTime() -
                                  new Date().getTime()) /
                                  (1000 * 60 * 60 * 24)
                              )}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {/* Recent Tests Tab */}
              {activeTab === "recent" && (
                <div>
                  {gradesData.recentTests.map((test, index) => (
                    <div key={index} className="card mb-3 border">
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-start">
                          <div className="d-flex align-items-center">
                            <div
                              className={`avatar avatar-sm bg-${getGradeColor(
                                test.grade
                              )} me-3`}
                            >
                              <i className="ti ti-file-text text-white"></i>
                            </div>
                            <div>
                              <h6 className="mb-1">{test.title}</h6>
                              <p className="text-muted mb-0">{test.subject}</p>
                            </div>
                          </div>
                          <div className="text-end">
                            <span
                              className={`badge bg-${getGradeColor(
                                test.grade
                              )} mb-1`}
                            >
                              {test.grade}
                            </span>
                            <br />
                            <small className="text-muted">{test.score}</small>
                          </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center mt-2">
                          <span className="text-muted">
                            {new Date(test.date).toLocaleDateString()}
                          </span>
                          <span
                            className={`fw-bold text-${getGradeColor(
                              test.grade
                            )}`}
                          >
                            {test.percentage}%
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GradesOverview;
